/* eslint-disable */

//             ,d
//             88
// ,adPPYba, MM88MMM ,adPPYba,  8b,dPPYba,
// I8[    ""   88   a8"     "8a 88P'    "8a
// `"Y8ba,     88   8b       d8 88       d8
// aa    ]8I   88,  "8a,   ,a8" 88b,   ,a8"
// `"YbbdP"'   "Y888 `"YbbdP"'  88`YbbdP"'
//                             88
//                             88


//////////////////////////////////
//////////////////////////////////
//
//  DO NOT EDIT THIS FILE. THIS FILE IS AUTO GENERATED BASED ON the _root.tpl file
//  RUN `yarn build-design-docs` to generate a new version
//
//////////////////////////////////
//////////////////////////////////

import React from 'react';
import { Route, Switch } from 'react-router-dom';

// Pages
import ColorsPage from './pages/ColorsPage';
import GradientsPage from './pages/GradientsPage';
import AlertsPage from './pages/AlertsPage';
import AnnoucementContainerPage from './pages/AnnoucementContainerPage';
import AvatarPage from './pages/AvatarPage';
import AvatarGroupPage from './pages/AvatarGroupPage';
import BadgePage from './pages/BadgePage';
import BannerPage from './pages/BannerPage';
import BreadcrumbsPage from './pages/BreadcrumbsPage';
import ButtonsPage from './pages/ButtonsPage';
import CalendarPage from './pages/CalendarPage';
import CardsPage from './pages/CardsPage';
import CheckboxPage from './pages/CheckboxPage';
import CollapsiblePage from './pages/CollapsiblePage';
import CollapsibleGroupPage from './pages/CollapsibleGroupPage';
import ContainersPage from './pages/ContainersPage';
import ContextMenuPage from './pages/ContextMenuPage';
import DateInputPage from './pages/DateInputPage';
import DayPickerPage from './pages/DayPickerPage';
import DividerPage from './pages/DividerPage';
import DrawerPage from './pages/DrawerPage';
import DropdownsPage from './pages/DropdownsPage';
import EmojiPage from './pages/EmojiPage';
import FeedbackButtonsPage from './pages/FeedbackButtonsPage';
import FormsPage from './pages/FormsPage';
import GifPickerPage from './pages/GifPickerPage';
import IconsPage from './pages/IconsPage';
import IllustrationPage from './pages/IllustrationPage';
import LinkPage from './pages/LinkPage';
import ListPage from './pages/ListPage';
import MenuPage from './pages/MenuPage';
import ModalsPage from './pages/ModalsPage';
import PopoverPage from './pages/PopoverPage';
import ProgressPage from './pages/ProgressPage';
import ReactionsPage from './pages/ReactionsPage';
import RichTextPage from './pages/RichTextPage';
import SelectPage from './pages/SelectPage';
import StepsPage from './pages/StepsPage';
import Steps2Page from './pages/Steps2Page';
import DataTablePage from './pages/DataTablePage';
import TabsPage from './pages/TabsPage';
import TextPage from './pages/TextPage';
import TextTruncatePage from './pages/TextTruncatePage';
import TimeInputPage from './pages/TimeInputPage';
import ToastPage from './pages/ToastPage';
import ToggleButtonPage from './pages/ToggleButtonPage';
import ToggleSwitchPage from './pages/ToggleSwitchPage';
import TooltipPage from './pages/TooltipPage';
import UserInputPage from './pages/UserInputPage';

import HomePage from './HomePage';  
 

// Components
import { WpMenu, WpMenuItem, WpMenuDivider } from '../../components/menu';
import WpIcon from '../../components/icon/WpIcon';

// Styles
import './WpdsDocs.scss';

const WpdsDocs = () => {
  return (
    <div className="WpdsDocs">
      <div className="WpdsDocs__menu">
        <WpMenu>
         <WpMenuItem to="/wpds" exact><WpIcon name="home" />Home</WpMenuItem>
         <WpMenuDivider />
          <WpMenuItem to="/wpds/utilities">
  <WpIcon name="circle" />Utilities
</WpMenuItem>
 <WpMenu><WpMenuItem to="/wpds/colors">
  <WpIcon name="palette" />Colors
</WpMenuItem>
 ,<WpMenuItem to="/wpds/gradients">
  <WpIcon name="palette" />Gradients
</WpMenuItem>
 </WpMenu><WpMenuItem to="/wpds/components">
  <WpIcon name="circle" />Components
</WpMenuItem>
 <WpMenu><WpMenuItem to="/wpds/alerts">
  <WpIcon name="exclamation-circle" />Alerts
</WpMenuItem>
 ,<WpMenuItem to="/wpds/annoucement-container">
  <WpIcon name="circle" />Annoucement Container
</WpMenuItem>
 ,<WpMenuItem to="/wpds/avatar">
  <WpIcon name="grin-alt" />Avatar
</WpMenuItem>
 ,<WpMenuItem to="/wpds/avatar-group">
  <WpIcon name="circle" />Avatar Group
</WpMenuItem>
 ,<WpMenuItem to="/wpds/badge">
  <WpIcon name="tag" />Badge
</WpMenuItem>
 ,<WpMenuItem to="/wpds/banner">
  <WpIcon name="pennant" />Banner
</WpMenuItem>
 ,<WpMenuItem to="/wpds/breadcrumbs">
  <WpIcon name="circle" />Breadcrumbs
</WpMenuItem>
 ,<WpMenuItem to="/wpds/buttons">
  <WpIcon name="mouse" />Buttons
</WpMenuItem>
 ,<WpMenuItem to="/wpds/calendar">
  <WpIcon name="calendar" />Calendar
</WpMenuItem>
 ,<WpMenuItem to="/wpds/cards">
  <WpIcon name="circle" />Cards
</WpMenuItem>
 ,<WpMenuItem to="/wpds/checkbox">
  <WpIcon name="circle" />Checkbox
</WpMenuItem>
 ,<WpMenuItem to="/wpds/collapsible">
  <WpIcon name="circle" />Collapsible
</WpMenuItem>
 ,<WpMenuItem to="/wpds/collapsible-group">
  <WpIcon name="circle" />Collapsible Group
</WpMenuItem>
 ,<WpMenuItem to="/wpds/containers">
  <WpIcon name="circle" />Containers
</WpMenuItem>
 ,<WpMenuItem to="/wpds/context-menu">
  <WpIcon name="circle" />Context Menu
</WpMenuItem>
 ,<WpMenuItem to="/wpds/date-input">
  <WpIcon name="circle" />Date Input
</WpMenuItem>
 ,<WpMenuItem to="/wpds/day-picker">
  <WpIcon name="calendar-alt" />Day Picker
</WpMenuItem>
 ,<WpMenuItem to="/wpds/divider">
  <WpIcon name="minus" />Divider
</WpMenuItem>
 ,<WpMenuItem to="/wpds/drawer">
  <WpIcon name="circle" />Drawer
</WpMenuItem>
 ,<WpMenuItem to="/wpds/dropdowns">
  <WpIcon name="circle" />Dropdowns
</WpMenuItem>
 ,<WpMenuItem to="/wpds/emoji">
  <WpIcon name="circle" />Emoji
</WpMenuItem>
 ,<WpMenuItem to="/wpds/feedback-buttons">
  <WpIcon name="thumbs-up" />Feedback Buttons
</WpMenuItem>
 ,<WpMenuItem to="/wpds/forms">
  <WpIcon name="circle" />Forms
</WpMenuItem>
 ,<WpMenuItem to="/wpds/gif-picker">
  <WpIcon name="circle" />Gif Picker
</WpMenuItem>
 ,<WpMenuItem to="/wpds/icons">
  <WpIcon name="icons" />Icons
</WpMenuItem>
 ,<WpMenuItem to="/wpds/illustration">
  <WpIcon name="circle" />Illustration
</WpMenuItem>
 ,<WpMenuItem to="/wpds/link">
  <WpIcon name="link" />Link
</WpMenuItem>
 ,<WpMenuItem to="/wpds/list">
  <WpIcon name="circle" />List
</WpMenuItem>
 ,<WpMenuItem to="/wpds/menu">
  <WpIcon name="circle" />Menu
</WpMenuItem>
 ,<WpMenuItem to="/wpds/modals">
  <WpIcon name="window" />Modals
</WpMenuItem>
 ,<WpMenuItem to="/wpds/popover">
  <WpIcon name="circle" />Popover
</WpMenuItem>
 ,<WpMenuItem to="/wpds/progress">
  <WpIcon name="circle" />Progress
</WpMenuItem>
 ,<WpMenuItem to="/wpds/reactions">
  <WpIcon name="thumbs-up" />Reactions
</WpMenuItem>
 ,<WpMenuItem to="/wpds/rich-text">
  <WpIcon name="italic" />Rich Text
</WpMenuItem>
 ,<WpMenuItem to="/wpds/select">
  <WpIcon name="circle" />Select
</WpMenuItem>
 ,<WpMenuItem to="/wpds/steps">
  <WpIcon name="circle" />Steps
</WpMenuItem>
 ,<WpMenuItem to="/wpds/steps2">
  <WpIcon name="circle" />Steps2
</WpMenuItem>
 ,<WpMenuItem to="/wpds/data-table">
  <WpIcon name="circle" />Data Table
</WpMenuItem>
 ,<WpMenuItem to="/wpds/tabs">
  <WpIcon name="circle" />Tabs
</WpMenuItem>
 ,<WpMenuItem to="/wpds/text">
  <WpIcon name="text-size" />Text
</WpMenuItem>
 ,<WpMenuItem to="/wpds/text-truncate">
  <WpIcon name="circle" />Text Truncate
</WpMenuItem>
 ,<WpMenuItem to="/wpds/time-input">
  <WpIcon name="circle" />Time Input
</WpMenuItem>
 ,<WpMenuItem to="/wpds/toast">
  <WpIcon name="check-circle" />Toast
</WpMenuItem>
 ,<WpMenuItem to="/wpds/toggle-button">
  <WpIcon name="circle" />Toggle Button
</WpMenuItem>
 ,<WpMenuItem to="/wpds/toggle-switch">
  <WpIcon name="circle" />Toggle Switch
</WpMenuItem>
 ,<WpMenuItem to="/wpds/tooltip">
  <WpIcon name="circle" />Tooltip
</WpMenuItem>
 ,<WpMenuItem to="/wpds/user-input">
  <WpIcon name="user" />User Input
</WpMenuItem>
 </WpMenu>
        </WpMenu>
      </div>
      <Switch>
        <Route path="/wpds/colors" component={ColorsPage} exact />
<Route path="/wpds/gradients" component={GradientsPage} exact />
<Route path="/wpds/alerts" component={AlertsPage} exact />
<Route path="/wpds/annoucement-container" component={AnnoucementContainerPage} exact />
<Route path="/wpds/avatar" component={AvatarPage} exact />
<Route path="/wpds/avatar-group" component={AvatarGroupPage} exact />
<Route path="/wpds/badge" component={BadgePage} exact />
<Route path="/wpds/banner" component={BannerPage} exact />
<Route path="/wpds/breadcrumbs" component={BreadcrumbsPage} exact />
<Route path="/wpds/buttons" component={ButtonsPage} exact />
<Route path="/wpds/calendar" component={CalendarPage} exact />
<Route path="/wpds/cards" component={CardsPage} exact />
<Route path="/wpds/checkbox" component={CheckboxPage} exact />
<Route path="/wpds/collapsible" component={CollapsiblePage} exact />
<Route path="/wpds/collapsible-group" component={CollapsibleGroupPage} exact />
<Route path="/wpds/containers" component={ContainersPage} exact />
<Route path="/wpds/context-menu" component={ContextMenuPage} exact />
<Route path="/wpds/date-input" component={DateInputPage} exact />
<Route path="/wpds/day-picker" component={DayPickerPage} exact />
<Route path="/wpds/divider" component={DividerPage} exact />
<Route path="/wpds/drawer" component={DrawerPage} exact />
<Route path="/wpds/dropdowns" component={DropdownsPage} exact />
<Route path="/wpds/emoji" component={EmojiPage} exact />
<Route path="/wpds/feedback-buttons" component={FeedbackButtonsPage} exact />
<Route path="/wpds/forms" component={FormsPage} exact />
<Route path="/wpds/gif-picker" component={GifPickerPage} exact />
<Route path="/wpds/icons" component={IconsPage} exact />
<Route path="/wpds/illustration" component={IllustrationPage} exact />
<Route path="/wpds/link" component={LinkPage} exact />
<Route path="/wpds/list" component={ListPage} exact />
<Route path="/wpds/menu" component={MenuPage} exact />
<Route path="/wpds/modals" component={ModalsPage} exact />
<Route path="/wpds/popover" component={PopoverPage} exact />
<Route path="/wpds/progress" component={ProgressPage} exact />
<Route path="/wpds/reactions" component={ReactionsPage} exact />
<Route path="/wpds/rich-text" component={RichTextPage} exact />
<Route path="/wpds/select" component={SelectPage} exact />
<Route path="/wpds/steps" component={StepsPage} exact />
<Route path="/wpds/steps2" component={Steps2Page} exact />
<Route path="/wpds/data-table" component={DataTablePage} exact />
<Route path="/wpds/tabs" component={TabsPage} exact />
<Route path="/wpds/text" component={TextPage} exact />
<Route path="/wpds/text-truncate" component={TextTruncatePage} exact />
<Route path="/wpds/time-input" component={TimeInputPage} exact />
<Route path="/wpds/toast" component={ToastPage} exact />
<Route path="/wpds/toggle-button" component={ToggleButtonPage} exact />
<Route path="/wpds/toggle-switch" component={ToggleSwitchPage} exact />
<Route path="/wpds/tooltip" component={TooltipPage} exact />
<Route path="/wpds/user-input" component={UserInputPage} exact />

        <Route path="/wpds" component={HomePage} exact />
      </Switch>
    </div>
  );
};

export default WpdsDocs;
